import { get } from '../index';

// One request at a time per URL: on a model page the header drawer (twice,
// from two mount effects) and the page itself all asked for the projects
// list in the same instant - three 7.8 MB responses built at once on
// SpaceX's company (2026-09-17). Callers arriving while a request is out
// share it; the next call after it settles asks again.
const inFlight = new Map();
const shared = (path) => {
  if (!inFlight.has(path)) {
    const p = get(path);
    inFlight.set(path, p);
    const clear = () => { if (inFlight.get(path) === p) inFlight.delete(path); };
    p.then(clear, clear);
  }
  return inFlight.get(path);
};

// The projects list without model file lists (?slim=1, back/routes/
// projects.js): rows carry zipInfo.pathsCount and filesOmitted instead.
// A page that loads a model takes its project from getProjectById
// (hooks/useProjectFiles).
export const getProjects = () => {
  return shared('/projects?slim=1');
};

// Parent-project candidates for the Create / Edit project dropdown
// ({projects: [{_id, title}]}); company-wide for company admins.
export const getParentProjects = () => {
  return get('/projects/parents');
};

// One project with everything a viewer needs (GET /projects/:projectId),
// ~0.3 s where the whole list took 4-27 s.
export const getProjectById = (projectId) => {
  return shared(`/projects/${projectId}`);
};
